import { render, staticRenderFns } from "./free_detail.vue?vue&type=template&id=0b79943b&scoped=true&"
import script from "./free_detail.vue?vue&type=script&lang=js&"
export * from "./free_detail.vue?vue&type=script&lang=js&"
import style0 from "./free_detail.vue?vue&type=style&index=0&id=0b79943b&scoped=true&lang=scss&"
import style1 from "./free_detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79943b",
  null
  
)

export default component.exports